import React, { useEffect, useRef, useState } from 'react';
import './Features.css';
import stick1 from "../../Assets/stick_1.webp";
import stick2 from "../../Assets/stick_2.webp";
import stick3 from "../../Assets/stick_3.webp";
import PopupForm from '../../Form/PopupForm';

function Features() {
  const courseMoreRef = useRef(null);
  const [, setAnimateText] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Intersection Observer for section visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );
    const section = document.getElementById('challenge-section');
    if (section) observer.observe(section);
    return () => { if (section) observer.unobserve(section); };
  }, []);

  // Intersection Observer for animated text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateText(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (courseMoreRef.current) observer.observe(courseMoreRef.current);
    return () => observer.disconnect();
  }, []);

  const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  const challenges = [
    {
      icon: stick1,
      title: "Locked Potential",
      description: "Brilliant minds held back by poor communication skills"
    },
    {
      icon: stick2,
      title: "Silent Knowledge",
      description: "Understanding English but hesitating to speak"
    },
    {
      icon: stick3,
      title: "Barrier to Success",
      description: "Limited opportunities due to communication gaps"
    }
  ];

  return (
    <section id="challenge-section" className={`feature-challenge-section ${isVisible ? 'feature-visible' : ''}`}>
      <div className="feature-challenge-background">
        <div className="feature-wave feature-wave1"></div>
        <div className="feature-wave feature-wave2"></div>
        <div className="feature-particles">
          {[...Array(20)].map((_, index) => (
            <div
              key={index}
              className="feature-particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                width: `${Math.random() * 20 + 5}px`,
                height: `${Math.random() * 20 + 5}px`
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="feature-challenge-container">
        <div className="feature-challenge-heading">
          <h2>The Challenge We Address</h2>
          <p className="feature-heading-description">
            Breaking barriers to effective communication using English as a tool.
          </p>
        </div>

        <div className="feature-challenges-wrapper">
          {challenges.map((challenge, index) => (
            <div
              key={index}
              className={`feature-challenge-card ${isVisible ? 'feature-animate-in' : ''}`}
              style={{ animationDelay: `${index * 0.3}s` }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="feature-card-overlay"></div>
              <div className="feature-card-content">
                <div className={`feature-card-icon ${hoveredIndex === index ? 'feature-bounce' : ''}`}>
                  <img
                    src={challenge.icon}
                    alt={challenge.title}
                    width={100}
                    height={100}
                    loading="lazy"
                    decoding="async"
                    className="feature-stickman-img"
                  />
                </div>
                <h3>{challenge.title}</h3>
                <p>{challenge.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={`feature-action-section ${isVisible ? 'feature-animate-in' : ''}`}>
          <h3>Ready to overcome these challenges? Try our Free Trial</h3>
          <button className="feature-action-button" onClick={handleOpenForm}>
            Know Your Level
            <svg className="feature-button-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>

      {/* Popup Form Component */}
      <PopupForm isOpen={showForm} onClose={handleCloseForm} />
    </section>
  );
}

export default Features;
